module.exports = __webpack_public_path__ + "static/wpack/extracted/megaphonec382df125d286fba9d2715c8ce6dbb89.svg";